module.exports = __webpack_public_path__ + "static/media/jpg.d3ebb24c.svg";